import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import {isSubmitted} from 'ag-common/tools/fileStatus'
import Comment from '#components/m/Comment'
import Text from '#components/a/Text'
import Textarea from '#components/a/form/Textarea'

function AnswerComment({canView, canEdit, chapterStatus, kommentar, currentUserId, onChangeHandle}) {
  const showKommentar = canView && (kommentar || canEdit)

  if (!showKommentar) {
    return null
  }

  const kommentarText = kommentar && kommentar.text ? kommentar.text : ''

  const isReadOnly = !isSubmitted(chapterStatus) || !canEdit
  const userIdToShow = (kommentar && kommentar.authorId) || currentUserId
  return (
    <Comment authorId={userIdToShow}>
      {isReadOnly && <Text text={kommentarText} />}
      {!isReadOnly && (
        <Textarea
          placeholder={i18n.t('kommentar_edit_text')}
          defaultValue={kommentarText}
          rows={10}
          maxLength={1000}
          onChangeHandle={onChangeHandle}
          resize
        />
      )}
    </Comment>
  )
}

AnswerComment.propTypes = {
  canView: PropTypes.bool,
  canEdit: PropTypes.bool,
  kommentar: PropTypes.shape({
    authorId: PropTypes.number,
    text: PropTypes.string,
  }),
  chapterStatus: PropTypes.string,
  onChangeHandle: PropTypes.func,
  currentUserId: PropTypes.number,
}

export default AnswerComment
